import { Route, Switch } from "react-router-dom";
import modules from "./modules";
import { Callback } from "./components/auth/callback";
import { Logout } from "./components/auth/logout";
import { LogoutCallback } from "./components/auth/logoutCallback";
import { SilentRenew } from "./components/auth/silentRenew";
import PrivateRoute from "./routes/privateRoute";
import { Alert } from "@mui/material";
import { Snackbar } from "@mui/material";

export default function App() {
 

  return (
    <>
      <Switch>
        <Route exact={true} path="/signin-oidc" component={Callback} />
        <Route exact={true} path="/logout" component={Logout} />
        <Route
          exact={true}
          path="/logout/callback"
          component={LogoutCallback}
        />
        {/* <Route exact={true} path="/register" component={Register} /> */}
        <Route exact={true} path="/silentrenew" component={SilentRenew} />
        {modules.map(({ path, module, auth: authRequired }) => {
          if (authRequired)
            return <PrivateRoute key={path} path={path} component={module} />;
          else return <Route key={path} path={path} component={module} />;
        })}
      </Switch>
      {process.env.REACT_APP_ENVIROMENT_NAME && (
        <Snackbar
          open={true}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert severity="info">
            {process.env.REACT_APP_ENVIROMENT_NAME} Enviroment
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
